module.exports = __webpack_public_path__ + "img/logo.e27dd0a2.webp";